export { default } from "./DeleteTaskModal";
